
import { throwError as observableThrowError, Observable } from 'rxjs';

import { catchError } from 'rxjs/operators';
import { Injectable } from '@angular/core';


import { ServiceBase } from '@app/services/base.service';
import { DemonstrativoDeResultado } from '@app/models/demonstrativo-de-resultado.model';
import { HttpClient } from '@angular/common/http';

@Injectable()
export class DemonstrativoDeResultadoService extends ServiceBase {
  constructor(private http: HttpClient) {
    super();
  }
  adicionar(demonstrativoDeResultado: DemonstrativoDeResultado): Observable<any> {
    return this.http
      .post<any>(this.URL_API + 'demonstrativoDeResultado', demonstrativoDeResultado).pipe(
        catchError((error: any) => observableThrowError(error)));
  }

  alterar(demonstrativoDeResultado: DemonstrativoDeResultado): Observable<any> {
    return this.http
      .put<any>(this.URL_API + 'demonstrativoDeResultado', demonstrativoDeResultado).pipe(
        catchError((error: any) => observableThrowError(error)));
  }

  deletar(id: number): Observable<any> {
    return this.http
      .delete<any>(this.URL_API + `demonstrativoDeResultado/${id}`).pipe(
        catchError((error: any) => observableThrowError(error)));
  }

  obterAutoComplete(): Observable<any> {
    return this.http
      .get<any>(this.URL_API + 'demonstrativoDeResultado/ObterAutoComplete');
  }

  obterPorId(id: number): Observable<any> {
    return this.http
      .get<any>(this.URL_API + `demonstrativoDeResultado/${id}`);
  }

  obterTodosSemGrupo(receitadespesa: string): Observable<any> {
    return this.http
      .get<any>(this.URL_API + `demonstrativoDeResultado/ObterTodosSemGrupo/${receitadespesa}`);
  }

  obterCompleto(): Observable<any> {
    return this.http
      .get<any>(this.URL_API + `demonstrativoDeResultado/completo`);
  }

}
